/*
 * @Author: Huangxianlong
 * @Date: 2023-08-11 16:44:08
 * @LastEditors: Huangxianlong
 * @LastEditTime: 2026-08-12 09:57:36
 * @FilePath: \monitor\src\language\report\from.js
 * @Description:
 */
const info = {
  CN: {
    open: "开启",
    close: "关闭",
    InOperation: "运行中（界面可访问，数据采集）",
    suspend: "暂停（界面不能访问，数据采集）",
    accessible: "可访问（界面可以访问，数据不采集）",
    stop: "停止（界面不能访问，数据不采集）",
    ordinaryDatalogger: "普通采集器",
    totalStationDatalogger: "全站仪",
    vibrationDatalogger: "振动采集器",
    accelerationDatalogger: "加速度采集器",
    normalStatus: "正常",
    warnStatus: "预警",
    alarmStatus: "告警",
    invalidStatus: "无效",
    projectName: "项目名称",
    proNamePla: "请选择项目名称",
    proNamePla1: "请输入项目名称",
    proNameRules: "项目名称不能为空",
    zone: "区域",
    zonePla: "请输入区域",
    zoneRules: "区域不能为空",
    category: "采集器类别",
    categoryPla: "请选择采集器类别",
    categoryPla1: "请输入采集器类别",
    categoryRules: "采集器类别不能为空",
    dataloggerName: "采集器名称",
    dataloggerNamePla: "请输入采集器名称",
    dataloggerNameSelectPla: "请选择采集器名称",
    dataloggerNameRules: "采集器名称不能为空",
    dataloggerNameReport: "采集器/分组名称",
    groupNameReport: "分组名称",
    dataloggerNameReportPla: "请输入采集器/分组名称",
    dataloggerNameReportSelectPla: "请选择采集器/分组名称",
    dataloggerNameReportRules: "采集器/分组名称不能为空",
    dataloggerDescription: "采集器描述",
    dataloggerDescriptionPla: "请输入采集器描述",
    dataloggerType: "采集器类型",
    dataloggerTypePla: "请选择采集器类型",
    dataloggerTypeRules: "采集器类型不能为空",
    dataloggerStatus: "采集器状态",
    dataloggerStatusPla: "请选择采集器状态",
    dataloggerStatusRules: "采集器状态不能为空",
    alertLevel: "告警级别",
    alertLevelPla: "请选择告警级别",
    alertLevelRules: "告警级别不能为空",
    dataloggerInterval: "采集周期",
    dataloggerIntervalPla: "请选择采集周期",
    dataloggerIntervalRules: "采集周期不能为空",
    longitude: "采集器位置经度",
    longitudePla: "请输入采集器位置经度",
    longitudeRules: "采集器位置经度不能为空",
    latitude: "采集器位置纬度",
    latitudePla: "请输入采集器位置纬度",
    latitudeRules: "采集器位置纬度不能为空",
    sensorId: "传感器编号",
    sensorIdPla: "请输入传感器编号",
    sensorIdPlaNo: "暂无传感器编号",
    sensorIdRules: "传感器编号不能为空",
    sensorName: "传感器名称",
    sensorNamePla: "请输入传感器名称",
    sensorNameSelectPla: "请选择传感器名称",
    sensorNamePlaNo: "暂无传感器名称",
    sensorNameRules: "传感器名称不能为空",
    sensorDescription: "传感器描述",
    sensorDescriptionPla: "请输入传感器描述",
    sensorStatus: "传感器状态",
    sensorStatusPla: "请选择传感器状态",
    sensorStatusRules: "传感器状态不能为空",
    palUp: "预警上限值",
    palUpPla: "请输入预警上限值",
    palUpRules: "预警上限值不能为空",
    palDown: "预警下限值",
    palDownPla: "请输入预警下限值",
    palDownRules: "预警下限值不能为空",
    alUp: "告警上限值",
    alUpPla: "请输入告警上限值",
    alUpRules: "告警上限值不能为空",
    alDown: "告警下限值",
    alDownPla: "请输入告警下限值",
    alDownRules: "告警下限值不能为空",
    pdlUp: "危险上限值",
    pdlUpPla: "请输入危险上限值",
    pdlUpRules: "危险上限值不能为空",
    pdlDown: "危险下限值",
    pdlDownPla: "请输入危险下限值",
    pdlDownRules: "危险下限值不能为空",
    wslUp: "停工上限值",
    wslUpPla: "请输入停工上限值",
    wslUpRules: "停工上限值不能为空",
    wslDown: "停工下限值",
    wslDownPla: "请输入停工下限值",
    wslDownRules: "停工下限值不能为空",
    warnValue: "预警值",
    warnValuePla: "请输入预警值",
    warnValueRules: "预警值不能为空",
    alarmValue: "告警值",
    alarmValuePla: "请输入告警值",
    alarmValueRules: "告警值不能为空",
    dangerValue: "危险值",
    dangerValuePla: "请输入危险值",
    dangerValueRules: "危险值不能为空",
    shutdownValue: "停工值",
    shutdownValuePla: "请输入停工值",
    shutdownValueRules: "停工值不能为空",
    sensorLongitude: "传感器位置经度",
    sensorLongitudePla: "请输入传感器位置经度",
    sensorLongitudeRules: "传感器位置经度不能为空",
    sensorLatitude: "传感器位置纬度",
    sensorLatitudePla: "请输入传感器位置纬度",
    sensorLatitudeRules: "传感器位置纬度不能为空",
    show: "显示",
    hide: "隐藏",
    projectDescription: "项目描述",
    projectDescriptionPla: "请输入项目描述",
    contacts: "联系人",
    contactsPla: "请输入联系人",
    contactsRules: "联系人不能为空",
    phone: "电话号码",
    phonePla: "请输入电话号码",
    phoneRules: "电话号码不能为空",
    projectTime: "项目时间",
    projectTimePla: "请选择项目时间",
    projectTimeRules: "项目时间不能为空",
    projectStatus: "项目状态",
    projectStatusPla: "请选择项目状态",
    projectStatusRules: "项目状态不能为空",
    projectLongitude: "项目位置经度",
    projectLongitudePla: "请输入项目位置经度",
    projectLongitudeRules: "项目位置经度不能为空",
    projectLatitude: "项目位置纬度",
    projectLatitudePla: "请输入项目位置纬度",
    projectLatitudeRules: "项目位置纬度不能为空",
    showCounter: "传感器统计模块",
    showCounterPla: "请选择传感器统计模块状态",
    showCounterRules: "传感器统计模块状态不能为空",
    showVideo: "视频模块",
    showVideoPla: "请选择视频模块状态",
    showVideoRules: "视频模块状态不能为空",
    zoneId: "区域编号",
    zoneIdPla: "请输入区域编号",
    zoneIdRules: "区域编号不能为空",
    zoneName: "区域名称",
    zoneNamePla: "请输入区域名称",
    zoneNameRules: "区域名称不能为空",
    latestReading: "最新读数",
    latestReadingPla: "暂无最新读数",
    latestReadingRules: "最新读数不能为空",
    latestChanges: "最新变化量",
    latestChangesPla: "暂无最新变化量",
    latestChangesRules: "最新变化量不能为空",
    initialValue: "初值",
    initialValuePla: "请输入初值",
    initialValueRules: "初值不能为空",
    time: "时间",
    timePla: "请选择时间",
    timeRules: "时间不能为空",
    aday: "近一天",
    aweek: "近一周",
    amonth: "近一个月",
    threemonths: "近三个月",
    exportPDF: "导出PDF",
    exportExcel: "导出Excel",
    noData: "暂无数据",
    reportTime: "报表时间",
    noReportsType: "暂无此类型采集器报表",
    selectConditionTip: "请选择查询条件生成报表",
    realtimeConditionTip: "请选择查询的传感器以及时间范围",
    warnMessage: "请选择查询的传感器以及时间范围",
    noDataMessage: "暂无传感器数据",
    eventNoData: "数据缺失",
    multipleSensorSelection: "传感器选择（应变，多选）",
    sensorSelection: "传感器选择（应变，单选）",
    youngsModulus: "杨氏模量 P₁",
    youngsModulusPla: "请输入杨氏模量P₁",
    youngsModulusRules: "杨氏模量P₁不能为空",
    calibrationCoefficient: "标定系数 K",
    calibrationCoefficientPla: "请输入标定系数K",
    calibrationCoefficientRules: "标定系数K不能为空",
    area: "面积 P₂(㎡)",
    areaPla: "请输入面积P₂",
    areaRules: "面积P₂不能为空",
    sensitivity: "灵敏度系数 p₁",
    sensitivityPla: "请输入灵敏度系数p₁",
    sensitivityRules: "灵敏度系数不能为空",
    temperatureP3: "温度补偿系数 p₃",
    temperatureP3Pla: "请输入温度补偿系数p₃",
    temperatureP3Rules: "温度补偿系数不能为空",
    batch: "批量系数 p₂",
    batchPla: "请输入批量系数p₂",
    batchRules: "批量系数不能为空",
    changeAmountUpdateTime: "变化量更新时间",
    changeAmountUpdateTimePla: "请选择变化量更新时间",
    changeAmountUpdateTimeRules: "变化量更新时间不能为空",
    initReadingTime: "初值时间",
    initReadingTimePla: "请选择初值时间",
    initReadingTimeRules: "初值时间不能为空",
    lastDataTime: "数据处理起始时间",
    lastDataTimePla: "请选择数据处理起始时间",
    lastDataTimeRules: "数据处理起始时间不能为空",
    lastHz: "最新Hz读数",
    lastHzPla: "暂无最新Hz读数",
    lastHzRules: "最新Hz读数不能为空",
    lastT: "最新T读数",
    lastTPla: "暂无最新T读数",
    lastTRules: "最新T读数不能为空",
    hzReading: "Hz初值",
    hzReadingPla: "请输入Hz初值",
    hzReadingRules: "Hz初值不能为空",
    tReading: "T初值",
    tReadingPla: "请输入T初值",
    tReadingRules: "T初值不能为空",
    groupName: "分组名称",
    groupNamePla: "请输入分组名称",
    groupNameRules: "分组名称不能为空",
    cycle: "采集周期",
    cyclePla: "请选择采集周期",
    cycleRules: "采集周期不能为空",
    maxNum: "最大位置序号",
    maxNumPla: "请输入最大位置序号",
    maxNumRules: "最大位置序号不能为空",
    groupSelect: "分组选择",
    groupSelectPla: "请选择分组",
    groupSelectRules: "分组不能为空",
    locationNumber: "位置序号",
    locationNumberPla: "请输入位置序号",
    locationNumberRules: "位置序号不能为空",
    elasticModulus: "弹性模量 E",
    elasticModulusPla: "请输入弹性模量",
    elasticModulusRules: "弹性模量不能为空",
    PALALWSL: "预警/告警/停工",
    ALWSL: "告警/停工",
    ALPDL: "告警/危险",
    AL: "告警",
    noWarning: "无告警",
    workingMode: "工作模式",
    workingModePla: "请选择工作模式",
    workingModeRules: "工作模式不能为空",
    continuous: "连续",
    interval: "间隔",
    recordingTime: "记录时间",
    recordingTimePla: "请输入记录时间",
    recordingTimeRules: "记录时间不能为空",
    samplingRate: "采样率",
    samplingRatePla: "请选择采样率",
    samplingRateRules: "采样率不能为空",
    range: "量程",
    rangePla: "请选择量程",
    rangeRules: "量程不能为空",
    collectionPrompt:
      "采集周期的更改，将在下一个周期生效（将远程更改设备配置）",
    prompt:
      "工作模式、采集周期、记录时间、采样率和量程的更改，将在下一个周期生效（将远程更改设备配置）",
    dataFileReturnMode: "数据文件返回模式",
    dataFileReturnModePla: "请选择数据文件返回模式",
    dataFileReturnModeRules: "数据文件返回模式不能为空",
    returnImmediately: "立即返回",
    doNotReturn: "不返回",
    data: "数值",
    unit: "单位",
    frequency: "频率(Hz)",
    temperature: "温度(℃)",
    strain: "应变(us)",
    stress: "应力(MPa)",
    quality: "质量指标",
    voltage: "电压",
    temp: "温度",
    graphicType: "图形类型",
    graphicTypePla: "请选择图形类型",
    graphicTypeRules: "图形类型不能为空",
    levelAlarmRules: "告警不能为空",
    levelAlarm: "告警",
    totalNumberOfSensors: "传感器总数",
    totalNumberOfSensorsPla: "请输入传感器总数",
    totalNumberOfSensorsRules: "传感器总数不能为空",
    numberOfActiveSensors: "传感器有效个数",
    numberOfActiveSensorsPla: "请输入传感器有效个数",
    numberOfActiveSensorsRules: "传感器有效个数不能为空",
    groundElevation: "地面高程",
    groundElevationPla: "请输入地面高程",
    groundElevationRules: "地面高程不能为空",
    pipeTopLevel: "管顶部高程",
    pipeTopLevelPla: "请输入管顶部高程",
    pipeTopLevelRules: "管顶部高程不能为空",
    sensorLength: "传感器长度",
    sensorLengthPla: "请输入传感器长度",
    sensorLengthRules: "传感器长度不能为空",
    curveTypePla: "请选择曲线类型",
    curveTypeRules: "曲线类型不能为空",
    timeGroup: "时间点",
    timeGroupPla: "请选择时间点",
    timeGroupRules: "时间点不能为空",
    selectSensor: "传感器",
    selectSensorPla: "请选择传感器",
    selectSensorRules: "传感器不能为空",
    selectAll: "全选",
    reportDate: "报告日期",
    reportDatePla: "请选择报告日期",
    reportDateRules: "报告日期不能为空",
    StrainGaugeMonitoringReport: "应变计监测报告",
    TotalStationMonitoringReport: "全站仪监测报告",
    project: "项目",
    strainGaugeLocation: "应变计位置",
    VWStrainGauge: "应变计名称",
    alertLevelValue: "告警值",
    al: "告警值",
    wsl: "停工值",
    pdl: "危险值",
    initalDate: "初值时间",
    crossSectionAreaOfStrut: "支柱横截面积 (m²)",
    elasticityModulus: "杨氏模量 (KN/mm²)",
    date: "时间",
    strain: "应变 (uε)",
    loadInStrut: "支柱载荷 (KN)",
    changeFromPrevious: "支柱载荷变化量 (KN)",
    remark: "备注",
    channel: "通道",
    reportDate1: "报告日期-1",
    reportDate1Pla: "请选择报告日期-1",
    reportDate1Rules: "报告日期-1不能为空",
    reportDate2: "报告日期-2",
    reportDate2Pla: "请选择报告日期-2",
    reportDate2Rules: "报告日期-2不能为空",
    direction: "方向",
    initialReading: "初始值",
    variation: "与上次数据相比",
    changeFromInitialReadings: "与初始值相比",
    projectDescription: "项目描述",
    numberOfMonitoringPoints: "监测点个数（不含基准点）",
    numberOfMonitoringPointsPla: "请输入监测点个数",
    numberOfMonitoringPointsRules: "监测点个数不能为空",
    details: "详情",
    dataTime: "时间范围",
    dataTimePla: "请选择时间范围",
    dataTimeRules: "时间范围不能为空",
    columnCount: "表格中传感器并列个数",
    columnCountPla: "请输入表格中传感器并列个数",
    columnCountRules: "表格中传感器并列个数不能为空",
    frequency: "数据时间间隔",
    frequencyPla: "请选择数据时间间隔",
    frequencyRules: "数据时间间隔不能为空",
    lastCycleEpoch: "数据处理起始时间",
    lastCycleEpochPla: "请选择数据处理起始时间",
    lastCycleEpochRules: "数据处理起始时间不能为空",
    lastCycleID: "处理周期编码",
    lastCycleIDPla: "请输入处理周期编码",
    lastCycleIDRules: "处理周期编码不能为空",
    cycleCount: "周期数",
    cycleCountPla: "请输入周期数",
    cycleCountRules: "周期数不能为空",
    inputFromFtp: "输出文件状态",
    inputFromFtpPla: "请选择输出文件状态",
    inputFromFtpRules: "输出文件状态不能为空",
    sendAlertSMS: "告警邮件状态",
    sendAlertSMSPla: "请选择告警邮件状态",
    sendAlertSMSRules: "告警邮件状态不能为空",
    tableType: "报表类型",
    tableTypePla: "请选择报表类型",
    tableTypeRules: "报表类型不能为空",
    summaryTable: "汇总表",
    detailedTable: "详细表",
    batchExport: "PDF批量导出所选",
    batchExportExcel: "Excel批量导出所选",
    batchExportWarn: "请选择需要导出的传感器",
    userLimit: "限制用户数量",
    userLimitPla: "请输入限制用户数量",
    userLimitRules: "限制用户数量不能为空",
  },
  EN: {
    open: "open",
    close: "close",
    InOperation: "In Operation（Accessible interface, data collection）",
    suspend: "Suspend（Interface not accessible, data collection）",
    accessible: "Accessible（Accessible interface, data not collected）",
    stop: "Stop（Interface not accessible, data not collected）",
    ordinaryDatalogger: "Ordinary Datalogger",
    totalStationDatalogger: "TotalStation",
    vibrationDatalogger: "Vibration Datalogger",
    accelerationDatalogger: "Acceleration Datalogger",
    normalStatus: "normal",
    warnStatus: "warn",
    alarmStatus: "alarm",
    invalidStatus: "invalid",
    projectName: "Project Name",
    proNamePla: "Please select a project name",
    proNamePla1: "Please input a project name",
    proNameRules: "Project name cannot be empty",
    zone: "Zone",
    zonePla: "Please enter the zone",
    zoneRules: "Zone cannot be empty",
    category: "Category",
    categoryPla: "Please select a category",
    categoryPla1: "Please input a category",
    categoryRules: "Category cannot be empty",
    dataloggerName: "Datalogger Name",
    dataloggerNamePla: "Please input a datalogger name",
    dataloggerNameSelectPla: "Please select a datalogger name",
    dataloggerNameRules: "Datalogger Name cannot be empty",
    dataloggerNameReport: "Datalogge/Group Name",
    groupNameReport: "Group Name",
    dataloggerNameReportPla: "Please input a datalogger/group name",
    dataloggerNameReportSelectPla: "Please select a datalogger/group name",
    dataloggerNameReportRules: "Datalogger/Group Name cannot be empty",
    dataloggerDescription: "Datalogger Description",
    dataloggerDescriptionPla: "Please input a datalogger description",
    dataloggerType: "Datalogger Type",
    dataloggerTypePla: "Please select a datalogger type",
    dataloggerTypeRules: "Datalogger type cannot be empty",
    dataloggerStatus: "Datalogger Status",
    dataloggerStatusPla: "Please select a datalogger status",
    dataloggerStatusRules: "Datalogger Status cannot be empty",
    alertLevel: "Alert Level",
    alertLevelPla: "Please select a alert level",
    alertLevelRules: "Alert Level cannot be empty",
    dataloggerInterval: "Datalogger Interval",
    dataloggerIntervalPla: "Please select a datalogger interval",
    dataloggerIntervalRules: "Datalogger Interval cannot be empty",
    longitude: "Longitude",
    longitudePla: "Please input a longitude",
    longitudeRules: "Longitude cannot be empty",
    latitude: "Latitude",
    latitudePla: "Please input a latitude",
    latitudeRules: "Latitude cannot be empty",
    sensorId: "Sensor Id",
    sensorIdPla: "Please input a sensor id",
    sensorIdPlaNo: "There is currently no sensor number available",
    sensorIdRules: "Sensor Id cannot be empty",
    sensorName: "Sensor Name",
    sensorNamePla: "Please input a sensor name",
    sensorNameSelectPla: "Please select a sensor name",
    sensorNamePlaNo: "There is currently no sensor name available",
    sensorNameRules: "Sensor Name cannot be empty",
    sensorDescription: "Sensor Description",
    sensorDescriptionPla: "Please input a sensor description",
    sensorStatus: "Sensor Status",
    sensorStatusPla: "Please select a sensor status",
    sensorStatusRules: "Sensor Status cannot be empty",
    palUp: "Upper Warn Limit",
    palUpPla: "Please input a upper warn limit",
    palUpRules: "Upper warn limit cannot be empty",
    palDown: "Lower Warn Limit",
    palDownPla: "Please input a lower warn limit",
    palDownRules: "Lower warn limit cannot be empty",
    alUp: "Upper Alarm Limit",
    alUpPla: "Please input a upper alarm limit",
    alUpRules: "Upper alarm limit cannot be empty",
    alDown: "Lower Alarm Limit",
    alDownPla: "Please input a lower alarm limit",
    alDownRules: "Lower alarm limit cannot be empty",
    pdlUp: "Upper Danger Limit",
    pdlUpPla: "Please input a upper danger limit",
    pdlUpRules: "Upper danger limit cannot be empty",
    pdlDown: "Lower Danger Limit",
    pdlDownPla: "Please input a lower danger limit",
    pdlDownRules: "Lower danger limit cannot be empty",
    wslUp: "Upper Shutdown Limit",
    wslUpPla: "Please input a upper shutdown limit",
    wslUpRules: "Upper shutdown limit cannot be empty",
    wslDown: "Lower Shutdown Limit",
    wslDownPla: "Please input a lower shutdown limit",
    wslDownRules: "Lower shutdown limit cannot be empty",
    warnValue: "PAL",
    warnValuePla: "Please input a PAL",
    warnValueRules: "PAL cannot be empty",
    alarmValue: "AL",
    alarmValuePla: "Please input a AL",
    alarmValueRules: "AL cannot be empty",
    dangerValue: "PDL",
    dangerValuePla: "Please input a PDL",
    dangerValueRules: "PDL cannot be empty",
    shutdownValue: "WSL",
    shutdownValuePla: "Please input a WSL",
    shutdownValueRules: "WSL cannot be empty",
    sensorLongitude: "Longitude",
    sensorLongitudePla: "Please input a longitude",
    sensorLongitudeRules: "Longitude cannot be empty",
    sensorLatitude: "Latitude",
    sensorLatitudePla: "Please input a latitude",
    sensorLatitudeRules: "Latitude cannot be empty",
    show: "show",
    hide: "hide",
    projectDescription: "Project Description",
    projectDescriptionPla: "Please enter a project description",
    contacts: "Contacts",
    contactsPla: "Please input a contacts",
    contactsRules: "Contacts cannot be empty",
    phone: "Phone",
    phonePla: "Please input a phone",
    phoneRules: "Phone cannot be empty",
    projectTime: "Project Time",
    projectTimePla: "Please select a project time",
    projectTimeRules: "Project time cannot be empty",
    projectStatus: "Project Status",
    projectStatusPla: "Please select a project status",
    projectStatusRules: "Project status cannot be empty",
    projectLongitude: "Longitude",
    projectLongitudePla: "Please input a longitude",
    projectLongitudeRules: "Longitude cannot be empty",
    projectLatitude: "Latitude",
    projectLatitudePla: "Please input a latitude",
    projectLatitudeRules: "Latitude cannot be empty",
    showCounter: "Sensor Statistics Module",
    showCounterPla: "Please select a sensor statistics module",
    showCounterRules: "Sensor statistics module cannot be empty",
    showVideo: "Video Module",
    showVideoPla: "Please select a video module",
    showVideoRules: "Video module cannot be empty",
    zoneId: "Zone Id",
    zoneIdPla: "Please input a zone id",
    zoneIdRules: "Zone id cannot be empty",
    zoneName: "Zone Name",
    zoneNamePla: "Please input a zone name",
    zoneNameRules: "Zone name cannot be empty",
    latestReading: "Latest Reading",
    latestReadingPla: "There are currently no latest readings available",
    latestReadingRules: "Latest reading cannot be empty",
    latestChanges: "Latest Changes",
    latestChangesPla: "There are currently no latest changes",
    latestChangesRules: "Latest changes cannot be empty",
    initialValue: "Initial Value",
    initialValuePla: "Please input a initial value",
    initialValueRules: "Initial value cannot be empty",
    time: "Time",
    timePla: "Please select a time",
    timeRules: "Time cannot be empty",
    aday: "A Day",
    aweek: "A Week",
    amonth: "A Month",
    threemonths: "Three Month",
    exportPDF: "Export PDF",
    exportExcel: "Export Excel",
    noData: "No Data",
    reportTime: "Report Time",
    noReportsType: "There are currently no reports for this type of collector",
    selectConditionTip: "Please select the query criteria to generate a report",
    realtimeConditionTip:
      "Please select the sensor and time range for the query",
    warnMessage: "Please select the sensor and time range for the query",
    noDataMessage: "There is currently no sensor data available",
    eventNoData: "Missing Data",
    multipleSensorSelection: "Sensor selection (strain, multiple choice)",
    sensorSelection: "Sensor selection (strain, single choice)",
    youngsModulus: "Young's modulus P₁",
    youngsModulusPla: "Please input a Young's modulus",
    youngsModulusRules: "Young's modulus cannot be empty",
    calibrationCoefficient: "Calibration coefficient K",
    calibrationCoefficientPla: "Please enter the calibration coefficient K",
    calibrationCoefficientRules:
      "The calibration coefficient K cannot be empty",
    area: "area P₂(㎡)",
    areaPla: "Please input the area",
    areaRules: "Area cannot be empty",
    sensitivity: "Sensitivity coefficient",
    sensitivityPla: "Please enter sensitivity coefficient",
    sensitivityRules: "Sensitivity coefficient cannot be empty",
    temperatureP3: "Temperature compensation coefficient p₃",
    temperatureP3Pla: "Please enter the temperature compensation coefficient",
    temperatureP3Rules:
      "The temperature compensation coefficient cannot be empty",
    batch: "Batch coefficient p₂",
    batchPla: "Please enter the batch factor",
    batchRules: "Batch coefficient cannot be empty",
    changeAmountUpdateTime: "Change update time",
    changeAmountUpdateTimePla:
      "Please select the update time for the change amount",
    changeAmountUpdateTimeRules: "Change update time cannot be empty",
    initReadingTime: "Init reading time",
    initReadingTimePla: "No init reading time available at the moment",
    initReadingTimeRules: "Init reading time cannot be empty",
    lastDataTime: "Starting time of data processing",
    lastDataTimePla: "Please enter the start time of data processing",
    lastDataTimeRules: "The start time of data processing cannot be empty",
    lastHz: "Latest Hz reading",
    lastHzPla: "There is currently no latest Hz reading available",
    lastHzRules: "The latest Hz reading cannot be empty",
    lastT: "Latest T reading",
    lastTPla: "There is currently no latest T reading available",
    lastTRules: "The latest T reading cannot be empty",
    hzReading: "Initial value of Hz",
    hzReadingPla: "Please enter the initial value of Hz",
    hzReadingRules: "The initial value of Hz cannot be empty",
    tReading: "Initial value of T",
    tReadingPla: "Please enter the initial value of T",
    tReadingRules: "The initial value of T cannot be empty",
    groupName: "Group Name",
    groupNamePla: "Please enter the group name",
    groupNameRules: "The group name cannot be empty",
    cycle: "Cycle",
    cyclePla: "Please select the collection period",
    cycleRules: "The collection period cannot be empty",
    maxNum: "Maximum Position Number",
    maxNumPla: "Please enter the maximum position number",
    maxNumRules: "The maximum position number cannot be empty",
    groupSelect: "Group Selection",
    groupSelectPla: "Please select a group",
    groupSelectRules: "Grouping cannot be empty",
    locationNumber: "Location Number",
    locationNumberPla: "Please enter the location number",
    locationNumberRules: "The position number cannot be empty",
    elasticModulus: "Elastic Modulus E",
    elasticModulusPla: "Please enter the elastic modulus",
    elasticModulusRules: "The elastic modulus cannot be empty",
    PALALWSL: "PAL/AL/WSL",
    ALWSL: "AL/WSL",
    ALPDL: "AL/PDL",
    AL: "AL",
    noWarning: "No warning",
    workingMode: "Working Mode",
    workingModePla: "Please select the working mode",
    workingModeRules: "Working mode cannot be empty",
    continuous: "continuous",
    interval: "interval",
    recordingTime: "Recording Time",
    recordingTimePla: "Please enter the recording time",
    recordingTimeRules: "Recording time cannot be empty",
    samplingRate: "Sampling Rate",
    samplingRatePla: "Please select the sampling rate",
    samplingRateRules: "Sampling rate cannot be empty",
    range: "Range",
    rangePla: "Please select the range",
    rangeRules: "Range cannot be empty",
    collectionPrompt:
      "The change in the datalogger interval will take effect in the next cycle (remote device configuration will be changed)",
    prompt:
      "Changes in working mode, datalogger interval, recording time, sampling rate, and range will take effect in the next cycle (remote device configuration changes will be made)",
    dataFileReturnMode: "Data file return mode",
    dataFileReturnModePla: "Please select the data file return mode",
    dataFileReturnModeRules: "The data file return mode cannot be empty",
    returnImmediately: "Return immediately",
    doNotReturn: "Do not return",
    data: "Data",
    unit: "Unit",
    frequency: "Frequency(Hz)",
    temperature: "Temperature(℃)",
    strain: "Strain(us)",
    stress: "Stress(MPa)",
    quality: "Quality Index",
    voltage: "Voltage",
    temp: "Temperature",
    graphicType: "Graphic type",
    graphicTypePla: "Please select the graphic type",
    graphicTypeRules: "The graphic type cannot be empty",
    levelAlarmRules: "Alarm cannot be empty",
    levelAlarm: "Alarm",
    totalNumberOfSensors: "Total number of sensors",
    totalNumberOfSensorsPla: "Please enter Total number of sensors",
    totalNumberOfSensorsRules: "Total number of sensors cannot be empty",
    numberOfActiveSensors: "Number of active sensors",
    numberOfActiveSensorsPla: "Please enter Number of active sensors",
    numberOfActiveSensorsRules: "Number of active sensors cannot be empty",
    groundElevation: "Ground Level",
    groundElevationPla: "Please enter the ground level",
    groundElevationRules: "Ground level cannot be empty",
    pipeTopLevel: "Pipe Top Level",
    pipeTopLevelPla: "Please enter the pipe top level",
    pipeTopLevelRules: "Pipe top level cannot be empty",
    sensorLength: "Sensor Length",
    sensorLengthPla: "Please enter the length of the sensor",
    sensorLengthRules: "The length of the sensor cannot be empty",
    curveTypePla: "Please select curve type",
    curveTypeRules: "Curve type cannot be empty",
    timeGroup: "Time Point",
    timeGroupPla: "Please select a time point",
    timeGroupRules: "The time point cannot be empty",
    selectSensor: "Sensor",
    selectSensorPla: "Please select a sensor",
    selectSensorRules: "The sensor cannot be empty",
    selectAll: "Select All",
    reportDate: "Report Date",
    reportDatePla: "Please select the report date",
    reportDateRules: "Report date cannot be empty",
    StrainGaugeMonitoringReport: "Strain Gauge Monitoring Report",
    TotalStationMonitoringReport: "Prism Monitoring Report",
    project: "Project",
    strainGaugeLocation: "Strain Gauge Location",
    VWStrainGauge: "VW Strain Gauge",
    alertLevelValue: "Alert Level",
    al: "AL",
    wsl: "WSL",
    pdl: "PDL",
    initalDate: "Inital Datetime",
    crossSectionAreaOfStrut: "Cross Section Area (m²)",
    elasticityModulus: "Elasticity modulus (KN/mm²)",
    date: "Datetime",
    strain: "Strain (uε)",
    loadInStrut: "Load In Strut (KN)",
    changeFromPrevious: "Change From Previous (KN)",
    remark: "Remark",
    channel: "Channel",
    reportDate1: "Report Date 1",
    reportDate1Pla: "Please select the report date 1",
    reportDate1Rules: "Report date 1 cannot be empty",
    reportDate2: "Report Date 2",
    reportDate2Pla: "Please select the report date 2",
    reportDate2Rules: "Report date 2 cannot be empty",
    direction: "Direction",
    initialReading: "Initial Reading",
    variation: "Change From Previous",
    changeFromInitialReadings: "Change From Initial",
    projectDescription: "Project Description",
    numberOfMonitoringPoints:
      "Number of monitoring points (excluding reference points)",
    numberOfMonitoringPointsPla: "Please enter the number of monitoring points",
    numberOfMonitoringPointsRules:
      "The number of monitoring points cannot be empty",
    details: "Details",
    dataTime: "Time range",
    dataTimePla: "Please select time range",
    dataTimeRules: "Time range cannot be empty",
    columnCount: "Number of sensors in parallel in the table",
    columnCountPla:
      "Please enter the number of sensors in parallel in the table",
    columnCountRules:
      "The number of sensors in parallel in the table cannot be empty",
    frequency: "Data time interval",
    frequencyPla: "Please select the data time interval",
    frequencyRules: "The data time interval cannot be empty",
    lastCycleEpoch: "Last Cycle Epoch",
    lastCycleEpochPla: "Please select the last cycle epoch",
    lastCycleEpochRules: "Last cycle epoch cannot be empty",
    lastCycleID: "Last Cycle ID",
    lastCycleIDPla: "Please select the last cycle id",
    lastCycleIDRules: "Last cycle id cannot be empty",
    cycleCount: "Cycle Count",
    cycleCountPla: "Please select the cycle count",
    cycleCountRules: "Cycle count cannot be empty",
    inputFromFtp: "Input From Ftp",
    inputFromFtpPla: "Please select the input from ftp",
    inputFromFtpRules: "Input from ftp cannot be empty",
    sendAlertSMS: "Send Alert SMS",
    sendAlertSMSPla: "Please select the send alert SMS",
    sendAlertSMSRules: "Send alert SMS cannot be empty",
    tableType: "Table Type",
    tableTypePla: "Please select the table type",
    tableTypeRules: "Table type cannot be empty",
    summaryTable: "Summary Table",
    detailedTable: "Detailed Table",
    batchExport: "PDF Batch export the selected",
    batchExportExcel: "Excel Batch export the selected",
    batchExportWarn: "Please select the sensors to be exported",
    userLimit: "Limit the number of users",
    userLimitPla: "Please enter the limit of user quantity",
    userLimitRules: "The limit on the number of users cannot be empty",
  }
};
export default info; //需要暴露出去



// WEBPACK FOOTER //
// ./src/language/report/from.js